var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "nav side-nav-bar" }, [
    _c("li", { staticClass: "nav-item" }, [
      _c("span", { staticClass: "nav-link d-none d-lg-block" }, [
        _c(
          "p",
          {
            staticClass:
              "d-inline-block mr-3 mr-lg-0 mb-3 font-weight-normal text-uppercase"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$resourceString["account.SideBar.Header"]) +
                "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "collapse-toggle collapsed nav-link d-lg-none",
          attrs: {
            "data-toggle": "collapse",
            role: "button",
            href: "#navbar-acc-sidebar",
            "aria-expanded": "false",
            "aria-controls": "navbar-acc-sidebar"
          }
        },
        [
          _c(
            "p",
            {
              staticClass:
                "d-inline-block mr-3 mr-lg-0 mb-3 font-weight-normal text-uppercase"
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$resourceString["account.SideBar.Header"]) +
                  "\n        "
              ),
              _c("span", {
                staticClass: "png-icon png-icon-icons-glyph--k-mobile-menu "
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "border-accent-gray-alt d-none d-lg-block" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse d-lg-block",
          attrs: { id: "navbar-acc-sidebar" }
        },
        [
          _c(
            "ul",
            { staticClass: "nav row" },
            _vm._l(_vm.links, function(link) {
              return _c(
                "li",
                { key: link.href, staticClass: "nav-item mb-2 col-12" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link side-nav-item text-uppercase",
                      class:
                        link.text == _vm.selectedTab
                          ? "selected-page font-weight-bold"
                          : "",
                      attrs: { href: link.href }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(link.text) + "\n          "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }